import React, {useEffect, useRef, useState} from "react";
import "../../styles/products-styling/cleaned/product.css";
import HeaderComponent from "./headerComponent";
import InformationCard from "./informationCard";
import HorizontalMiniCards from "./horizontalMiniCards";
import Divider from "../generalComponents/divider";
import CTABanner from "../generalComponents/banners/CTABanner";
import AdvanceCTABanner from "../generalComponents/banners/advanceCTABanner";
import {BuiltForShopifyBadge, FacebookAdGraphic1, FacebookAdGraphic2, FacebookAdGraphic3} from "../../assets/assets";
import {ArrowRightIcon} from "@heroicons/react/16/solid";
import {useLocation} from "react-router-dom";
import TestimonialComponent from "../home/TestimonialComponent";
import TestimonialsSection from "./testimonialsSection";
import {sendSlackMessageTracked} from "../../models/notifications";
import SecondaryPricingComponent from "../SecondaryPricingComponent";
import ModernPricingView from "../pricing/modernPricingView";
import CarouselComponent from "../CarouselComponent";
import MainPopupForm from "../popupModules/mainPopupForm";

const SolutionComponent = () => {
  const location = useLocation();

  const cashbackRef = useRef();
  const membershipsRef = useRef();
  const storeCreditRefundsRef = useRef();

  const [hash, setHash] = useState();

  useEffect(() => {
    const hash = location.hash;
    setHash(hash)
    sendSlackMessageTracked("Lead is visiting the Cashback Solutions page.", "#website-updates")
  });

  // Scroll handler
  useEffect(() => {
    let referenceObject = null;
    let blockPosition = "center"
    if (hash) {
      switch (hash) {
        case "#cashback":
          referenceObject = cashbackRef;
          blockPosition = "start"
          break
        case "#shopify":
          referenceObject = membershipsRef;
          break
        case "#store-credit-refunds":
          referenceObject = storeCreditRefundsRef;
          break
      }
      if (referenceObject) {
        referenceObject.current.scrollIntoView({
          behavior: 'smooth', // Optional: Add smooth scrolling
          block: blockPosition
        });
      }
    }
  }, [hash]);


  return (
    <div
      className="page-template page-template-elementor_header_footer page
      page-id-1652 wp-custom-logo elementor-default
      elementor-template-full-width elementor-kit-159 elementor-page
      elementor-page-1652"
      // style={{ background: `#f9fafb` }}
    >
      <div
          data-elementor-type="wp-page"
          data-elementor-id={1652}
          className="elementor elementor-1652"
          data-elementor-post-type="page"
      >
        <HeaderComponent title="Turn sales into repeat sales. With cashback."
                         subtitle='Each seed has the potential to grow into something beautiful.'
                         subtitle={<div>Don't judge each day by the harvest you reap, but by the seeds that you
                           plant.&nbsp;<span className="italic">Each seed has the potential to grow into something beautiful.&nbsp;</span>
                         </div>}
                         items={[
                           {text: "💸 Cashback", ctaURL: "#cashback"},
                           {text: "🛒 Shopify", ctaURL: "#shopify"},
                           {text: "💲 Store credit", ctaURL: "#store-credit-refunds"}
                         ]}
        />

        <div ref={cashbackRef} className="space-y-12 mb-8">
          <InformationCard
              // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
              // image={FacebookAdGraphic3}
              image="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-6-2048x1429.png"
              // imageDirection="left"
              imageDirection="right"
              text="🆘 Shoppers are not coming back."
              ctaURL="/products/cashback"
              ctaString="Learn more about Cashback"
              subtext={
                <div>
                  Your seasonal buyers disappear for months.
                  Not because they don’t love your brand, but because you’re missing the systems to keep them engaged
                  between collections. Without touchpoints, customers default to "see you next season"
                  mode, leaving revenue stranded for 8-12 months.
                  <br/><br/>
                  Pabloo’s Cashback turns seasonal shoppers into year-round buyers, rewarding every purchase with
                  cashback store credits
                  that keep them coming back between collections.
                </div>
              }
          />


          <div className="flex justify-center">
            <CTABanner
                text="Ready to start planning your cashback?" ctaURL="/pricing" ctaString="Select program"
            />
          </div>

          <InformationCard
              // image={FacebookAdGraphic1}
              image={"https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-7.png"}
              imageDirection="left"
              ctaURL="/products/cashback"
              ctaString="Learn more about Cashback"
              // text="Plan your cashback ahead and get your north-star metrics."
              text="🚨 High churn after first purchase."
              // subtext="One-time purchases are leaving revenue on the table. Despite a strong initial conversion, 72% of
              // D2C customers never make a second purchase, forcing brands to spend more on reacquisition. It is 5x cheaper to
              // retain a customer than to reaquire a new one.
              // Using cashback allows you to specify an amount to give your customer after they complete a purchase.
              // Pabloo members see an average increase of over 35% on second-order rate.
              //         "
              subtext={<div>
                Retaining a paying customer is 5x more cost efficient than acquiring a new one.
                One-time purchases are costing you revenue. Despite strong initial conversions, 72% of D2C customers
                never return, forcing you to spend 5x more on reacquisition than retention.

                <br/><br/>
                Customer retention is your hidden profit lever. While brands obsess over acquisition, the real
                opportunity lies in keeping buyers engaged.
              </div>}
          />

        </div>

        <HorizontalMiniCards items={[
          {
            text: "Rising CAC",
            subtext: "Customer Acquisition Cost (CAC), the average spend to gain one paying customer.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Recurring-tasks-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Low LTV:CAC ratio",
            subtext: "A low ratio means you’re spending more to acquire customers than they’re worth long-term.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Add-to-backlog-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Declining AOV",
            subtext: "A falling Average Order Value (AOV) means customers are spending less per transaction. See below.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Filter-by-tags-icon.png",
            ctaURL: "/products/cashback",
          },
        ]}/>

        <div className="flex justify-center">
          <div className="w-3/4">
            <Divider/>
          </div>
        </div>


        <div ref={cashbackRef} className="space-y-12 mb-8">
          <InformationCard
              // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
              // image={FacebookAdGraphic3}
              image="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-6-2048x1429.png"
              // imageDirection="left"
              imageDirection="right"
              // text="🧨 Over-reliance on discounts."
              text="🧨 Discount addiction."
              // ctaURL="/products/cashback"
              // ctaString="Learn more about Cashback"
              subtext={
                <div>
                  Discounts are killing your margins. Beware of over-reliance on discounts.
                  {/*D2C brands use discounts as a crutch for retention, training customers to wait for promotions.*/}
                  {" "}While promotions might spike short-term sales, they train customers to wait for deals,
                  This erodes margins by 15-30%. This is visible with a declining AOV and Coupon
                  hunter<sub>1</sub> customer segments.
                </div>
              }
          />


          {/*<CTABanner*/}
          {/*    text="Ready to start planning your cashback?" ctaURL="/pricing" ctaString="Select program"*/}
          {/*/>*/}

          {/*<div className="md:px-12">*/}
          {/*  <TestimonialsSection />*/}
          {/*</div>*/}

          <div className="flex justify-center">
            <AdvanceCTABanner
                text={<div>Smarter payments.<br/>Accept store credit now.</div>}
                ctaString="Select program 💎"
                ctaURL="/pricing"
                imageSource="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/Pabloo%20Media%2Fgraph_image.svg?alt=media&token=653e9008-212a-4120-a537-03caf7c36ea4"
            />
          </div>

          <InformationCard
              // image={FacebookAdGraphic1}
              image={"https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-7.png"}
              imageDirection="left"
              // ctaURL="/products/cashback"
              // ctaString="Learn more about Cashback"
              // text="Plan your cashback ahead and get your north-star metrics."
              // text="❗️Poor post-purchase engagement."
              text="Silent profit killer! 92% of D2C brands ignore this."
              subtext={<div>The silent killer. Most brands abandon customers after their first purchase. After the sale,
                the brand goes silent.
                <br/><br/>If this is you, then it's important to know that the 45-day gap between first and second
                purchases is a black hole for D2C brands.
                Poor post-purchase engagement means 68% of customers forget your brand exists by their next buying
                occasion!
                Without automated nurturing, competitors swoop in with retargeting ads to steal customers.</div>}
          />

        </div>

        <HorizontalMiniCards items={[

          {
            text: "\"Coupon hunter\" customer segments.",
            subtext: "Coupon hunters are buyers who only purchase during sales. Over 70% of their orders rely on discount. " +
                "Abandon carts without promo codes. Multi-accounts to stack deals.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Add-to-backlog-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            // text: "Declining AOV",
            // text: "Lack of personalized replenishment reminders",
            text: "Cashback instead of discounts.",
            subtext: <div><strong>Get $10 back</strong> vs. <strong>10% off</strong> to preserves price integrity.<br/>
              <br/>
              <div className="italic">Spend $100 and get $15 cashback.</div>
            </div>,
            image: "https://planzer.io/wp-content/uploads/2023/01/Recurring-tasks-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Zero post-order email sequences.",
            subtext: "45% of D2C brands send zero emails between orders, missing high conversion windows.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Filter-by-tags-icon.png",
            ctaURL: "/products/cashback",
          },
        ]}/>

        <div className="flex justify-center">
          <div className="w-3/4">
            <Divider/>
          </div>
        </div>


        <div ref={membershipsRef} className="mt-32">

          <InformationCard
              // image={FacebookAdGraphic1}
              image={"https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-5.png"}
              // imageDirection="left"
              imageDirection="right"
              // text="Unlocking recurring revenue with deeper customer relationships"
              text="📛 No subscription or recurring revenue."
              subtext="Single-purchase transactions dominate D2C revenue, making brands vulnerable to cash flow gaps.
                        Without subscription options for replenishable goods, 60% of potential LTV goes unrealized.
                        Build an inner community for the 20% of customers who drive 80% of revenue.
                        Elite memberships makes valuable buyers feel valued.  "
          />

        </div>

        <HorizontalMiniCards items={[
          {
            text: "Customer relationship management (CRM)",
            subtext: "Your CRM should be a profit engine, not just a contact list.",
            image: "https://planzer.io/wp-content/uploads/2022/12/Plan-Your-Day.svg",
            ctaURL: "/products/cashback",
          },
          {
            text: "\"Streak\" bonuses",
            subtext: <div>Customers are encouraged to purchase more frequently. <br/><br/>
              <div className="italic">5 orders in 3 months → $25 bonus.</div>
            </div>,
            image: "https://planzer.io/wp-content/uploads/2023/01/Avoid-getting-stuck-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Buy-in",
            subtext: "Monetize exclusivity. Offer curated membership tiers that customers can buy through your Shopify store.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Finish-subtasks-icon.png",
            ctaURL: "/products/cashback",
          },
        ]}/>

        {/*<div className="flex justify-center">*/}
        {/*  <AdvanceCTABanner*/}
        {/*      text={<div>Explore what's next.<br/>Join the membership.</div>}*/}
        {/*      ctaString="Select program 💎"*/}
        {/*      ctaURL="/pricing"*/}
        {/*      imageSource="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/Pabloo%20Media%2Fgraph_image.svg?alt=media&token=653e9008-212a-4120-a537-03caf7c36ea4"*/}
        {/*  />*/}
        {/*</div>*/}

        {/*<div className="my-12">*/}
        {/*  <Divider />*/}
        {/*</div>*/}

        <div className="">
          <ModernPricingView/>
        </div>

        <div className="mb-8 mt-2">
          <CarouselComponent />
        </div>

        {/*<TestimonialsSection />*/}

        <MainPopupForm />


        {/*<div ref={storeCreditRefundsRef} className="mt-24 mb-12">*/}
        {/*  <InformationCard*/}
        {/*      image={FacebookAdGraphic2}*/}
        {/*      // image="https://planzer.io/wp-content/uploads/2023/01/lines-in-colors.svg"*/}
        {/*      imageDirection="left"*/}
        {/*      // imageDirection="right"*/}
        {/*      text="🛑 Ineffective loyalty programs."*/}
        {/*      subtext={<div>*/}
        {/*        Most loyalty programs fail because they reward the wrong behaviors, and make redemption needlessly complex.*/}
        {/*        Less than 12% of customers actively engage. These programs often lack urgency, excitement, or any real connection to customer spending habits.*/}

        {/*        <br /><br />*/}
        {/*        Reward what matters. Pabloo's Cashack allows you to give store credit to customers whenever they make a purchase.*/}
        {/*        Pabloo offers tiered incentives that motivate bigger spending, and eliminate redemption friction.*/}
        {/*      </div>}*/}
        {/*  />*/}
        {/*</div>*/}


        {/*<HorizontalMiniCards items={[*/}
        {/*  {*/}
        {/*    text: "Trigger replenishment cashback.",*/}
        {/*    subtext: "Trigger personalized rewards when customers need to reorder, like offering $10 credit when their product runs low.",*/}
        {/*    image: "https://planzer.io/wp-content/uploads/2023/01/9-integrations-icon.png",*/}
        {/*    ctaURL: "/products/cashback",*/}
        {/*  },*/}
        {/*  {*/}
        {/*    text: "No gamification or urgency.",*/}
        {/*    subtext: "We synchronise all your data in real-time, no need to refresh, just pull in your tasks and plan your day.",*/}
        {/*    image: "https://planzer.io/wp-content/uploads/2023/01/Recurring-tasks-icon.png",*/}
        {/*    ctaURL: "/products/cashback",*/}
        {/*  },*/}
        {/*  {*/}
        {/*    text: "Abandoned cart saver.",*/}
        {/*    subtext: "Offer $5 cashback if they complete checkout within 24 hours.",*/}
        {/*    image: "https://planzer.io/wp-content/uploads/2022/12/Time-blocking.svg",*/}
        {/*    ctaURL: "/products/cashback",*/}
        {/*  },*/}
        {/*]}/>*/}


        {/*<div className="flex justify-center">*/}
        {/*  <AdvanceCTABanner*/}
        {/*      text={<div>Explore what's next.<br/>Join the membership.</div>}*/}
        {/*      ctaString="Select program 💎"*/}
        {/*      ctaURL="/pricing"*/}
        {/*      imageSource="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/Pabloo%20Media%2Fgraph_image.svg?alt=media&token=653e9008-212a-4120-a537-03caf7c36ea4"*/}
        {/*  />*/}
        {/*</div>*/}

      </div>
    </div>
  );
};

export default SolutionComponent;
